import React from 'react';
import { PropTypes } from 'prop-types';
import Yup from 'yup';
import moment from 'moment';
import DateInput from '../../form/controls/DateInput';
import FieldAlert from '../../form/FieldAlert';

const createTaskSchema = Yup.object().shape({
  startTime: Yup
    .date()
    .nullable()
    .required("Start time is required"),
  endTime: Yup
    .date()
    .nullable()
    .required("End time is required")
    .when('startTime', (startTime, schema) => {
      if (startTime) {
        const minStart = moment(startTime).minute(15);
        return schema.min(minStart, "End time must be later than Start time");
      }
      return schema;
    })
});

const errorDivStyle = {
  color: "#f00",
  textAlign: "left",
  padding: "10px"
};

class CreateTaskForm extends React.Component {

  constructor(props) {
    super(props);

    this._localFormat = 'YYYY-MM-DD[T]HH:mm:ss';
    this._dateUIFormat = 'YYYY-MM-DD hh:mm A';
    this._timeInterval = 15;

    this._defaultState = {
      error: null,
      task: {
        startTime: undefined,
        endTime: undefined
      }
    };

    this.onChange = this.onChange.bind(this);
    this.onCreate = this.onCreate.bind(this);

    this.state = this._defaultState;
  }

  // componentDidMount() {
  //   this.setInitialState();
  // }

  setInitialState() {

    // const newTime = {
    //   startTime: moment().hour(8).minute(0).format(this._localFormat),
    //   endTime: moment().hour(20).minute(0).format(this._localFormat)
    // };

    this.setState(Object.assign({}, this._defaultState));
  }

  onChange(name, datetime) {

    const parsedDate = moment(datetime);

    let currentState = Object.assign({}, this.state.task);
    currentState[name] = parsedDate.isValid() ? parsedDate.format(this._localFormat) : null;

    this.setState({ task: currentState });
  }

  onCreate() {

    createTaskSchema
      .validate(this.state.task)
      .then(() => {
        Promise
          .resolve(this.props.onCreate(Object.assign({}, this.state.task)))
          .then(() => this.setInitialState())
          .catch(() => this.setState({ error: "Error processing the request" }));
      })
      .catch(error => {
        this.setState({ error: error.message });
      });
  }

  render() {
    return (
      <div className="add-sessions" style={{ textAlign: "left" }}>
        <FieldAlert style={errorDivStyle} message={this.state.error} />
        <label className="start">
          Start
          <DateInput
            name="startTime"
            showTimeSelect
            timeIntervals={this._timeInterval}
            dateFormat={this._dateUIFormat}
            onChange={this.onChange}
            value={this.state.task.startTime} />
        </label>
        <label className="end">
          End
          <DateInput
            name="endTime"
            showTimeSelect
            timeIntervals={this._timeInterval}
            dateFormat={this._dateUIFormat}
            onChange={this.onChange}
            value={this.state.task.endTime} />
        </label>
        <button style={{ top: "20px", right: 0 }} type="button" onClick={this.onCreate}>Add Task</button>
      </div>
    );
  }
}

CreateTaskForm.propTypes = {
  onCreate: PropTypes.func.isRequired
};

export default CreateTaskForm;



// WEBPACK FOOTER //
// ./src/components/projects/Tasks/CreateTaskForm.js